import React from 'react';
type TextFieldProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  name: string;
  error?: string;
  hint?: string;
};
export const fieldClass = 'mt-2 w-full rounded-[10px] border border-ink-line bg-[#141217] px-4 py-3 text-white placeholder:text-ink-faint transition-colors duration-150 ease-out focus:border-neon focus:outline-none focus:shadow-[0_0_0_3px_rgba(255,59,63,.18)]';
export function TextField({
  label,
  name,
  error,
  hint,
  required,
  className = '',
  ...rest
}: TextFieldProps) {
  const id = `field-${name}`;
  return <div className={className} data-id="element-77" data-mp="34gmu3s6ymhuo">
      <label htmlFor={id} className="font-slab text-sm font-bold uppercase tracking-[0.18em] text-cream" data-id="element-78" data-mp="39hanulmkpcsl">
        {label}
        {required && <span className="text-neon-2" data-id="element-79" data-mp="3ea3rf66b2f33"> *</span>}
      </label>
      <input id={id} name={name} required={required} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} className={`${fieldClass} ${error ? 'border-red-400' : ''}`} {...rest} data-id="element-80" data-mp="2gtojhb5iu44o" />
      {hint && !error && <p id={`${id}-hint`} className="mt-1.5 text-xs text-ink-faint" data-id="element-81" data-mp="1dgusdw8liq81">
          {hint}
        </p>}
      {error && <p id={`${id}-error`} className="mt-1.5 text-xs text-red-300" data-id="element-82" data-mp="18othoer2t7k4">
          {error}
        </p>}
    </div>;
}